import { render } from "./BonoConductorPage.vue?vue&type=template&id=1294643f"
import script from "./BonoConductorPage.vue?vue&type=script&lang=js"
export * from "./BonoConductorPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__